<template>
  <div class="modal fade text-center" id="created-subscription" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <modal-header></modal-header>
        <div class="modal-body">
          <p class="title">{{ $t('paymentResult') }}</p>
          <p>{{ $t('noticeInfo') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" @click="paymentCompleted">{{ $t('paymentCompleted') }}</button>
          <p>{{ $t('contactUsNotice') }}</p>
          <p class="email">iplexservice@gmail.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import locales from './lang'
  import $ from 'jquery'
  import ModalHeader from '../../modalHeader/ModalHeader.vue'

  export default {
    name: 'created-subscription',
    components: {ModalHeader},
    locales,
    computed: {
      showCurrentComponent() {
        let idFromUrl = this.$route.query.subscription_id
        let idFromStorage = window.localStorage.getItem('subscriptionId')
        return idFromUrl && idFromStorage && idFromUrl === idFromStorage
      }
    },
    mounted() {
      if (this.showCurrentComponent) {
        $('#created-subscription').modal('show')
      }
      let subscriptionId = window.localStorage.getItem('subscriptionId')
      this.$store.commit('setSubscriptionId', subscriptionId)
      let vmResult = this
      $('#created-subscription').on('hidden.bs.modal', function () {
        vmResult.paymentCompleted()
      })
    },
    methods: {
      paymentCompleted() {
        this.$store.commit('setQuerySubscriptionStatus', true)
        // Event snippet for subscribe_payment_result page
        window.dataLayer && window.dataLayer.push({'event': 'subscribe_payment_result'})
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/reset-modal";
  @import "../../../assets/scss/mixins/button";

  .modal-dialog {
    @include modal-dialog($height: 4.3rem);
    position: relative;
    @media (max-width: 767px) {
      margin: calc(50vh - 2.15rem) 0 0 -45% !important;
    }
  }

  .modal-body {
    p {
      font-size: .16rem;
      color: #333333;
      letter-spacing: .71px;
      line-height: .28rem;
      &.title {
        font-size: .24rem;
        letter-spacing: 0;
        margin-bottom: .6rem;
      }
    }
  }

  .modal-footer {
    text-align: center;
    position: absolute;
    bottom: .4rem;
    width: calc(100% - .4rem);
    button {
      @include modal-button();
      margin-bottom: .4rem;
    }
    p {
      line-height: .28rem;
      font-size: .12rem;
      color: #999999;
      letter-spacing: 0.53px;
      &.email {
        font-size: .14rem;
        color: #416CF8;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CreatedSubscription.vue?2c41ddc2